import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { IEditionMetadata, PackType } from '../../types/pack'
import { Modals } from '../../types/modal'
import { modalClose, modalOpen } from '../../actions/modal'
import { deleteFile } from '../../actions/pack'
import { selectActiveModal } from '../../selectors/modal'
import { P, Modal, DangerButton } from '../../components'

export interface IFileDeleteButtonComponent {
  pack: PackType
  edition: IEditionMetadata
  activeModal?: string
  dispatch: Dispatch
}

export const FileDeleteButtonComponent = ({
  pack,
  edition,
  activeModal,
  dispatch,
}: IFileDeleteButtonComponent) => (
  <>
    <DangerButton
      id="delete-edition-dialog"
      variant="text"
      fullWidth
      tabIndex={-1}
      onClick={() => dispatch(modalOpen(Modals.deleteConfirmModal))}
      disabled={!edition.canDelete}
    >
      Delete
    </DangerButton>
    <Modal
      id="delete-file-modal-dialog"
      open={activeModal === Modals.deleteConfirmModal}
      handleClose={() => {
        dispatch(modalClose())
      }}
      action={() => {
        dispatch(deleteFile(pack.id, edition.id))
        dispatch(modalClose())
      }}
      title="File deletion"
      actionLabel="Delete"
    >
      <P>
        This file will be deleted - please note that this action is not
        reversible and cannot be undone.
      </P>
      <br />
      <P>
        Are you sure you want to delete <b>{edition.editionName}</b> file?
      </P>
    </Modal>
  </>
)

const mapStateToProps = (state) => ({
  activeModal: selectActiveModal(state),
})

export const FileDeleteButton = connect(mapStateToProps)(
  FileDeleteButtonComponent
)
